var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", { staticClass: "mb-0" }, [
      _c("span", { staticClass: "badge badge-success" }, [_vm._v("З")]),
      _vm._v(": "),
      _c("strong", [
        _vm._v(_vm._s(Math.round((_vm.stats[3]?.total ?? 0) * 10) / 10)),
      ]),
      _vm._v("\n    ("),
      _c("strong", [_vm._v(_vm._s(_vm.getTotalPrice(_vm.stats[3]?.price)))]),
      _vm._v(") "),
      _vm.allShift
        ? _c("strong", [_vm._v(_vm._s(_vm.getPercent(3)) + "%")])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mb-0" }, [
      _c("span", { staticClass: "badge badge-info" }, [_vm._v("О")]),
      _vm._v(": "),
      _c("strong", [
        _vm._v(_vm._s(Math.round((_vm.stats[1]?.total ?? 0) * 10) / 10)),
      ]),
      _vm._v("\n    ("),
      _c("strong", [_vm._v(_vm._s(_vm.getTotalPrice(_vm.stats[1]?.price)))]),
      _vm._v(") "),
      _vm.allShift
        ? _c("strong", [_vm._v(_vm._s(_vm.getPercent(1)) + "%")])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mb-0" }, [
      _c("span", { staticClass: "badge badge-warning" }, [_vm._v("М")]),
      _vm._v(": "),
      _c("strong", [
        _vm._v(_vm._s(Math.round((_vm.stats[-2]?.total ?? 0) * 10) / 10)),
      ]),
      _vm._v("\n    ("),
      _c("strong", [_vm._v(_vm._s(_vm.getTotalPrice(_vm.stats[-2]?.price)))]),
      _vm._v(") "),
      _vm.allShift
        ? _c("strong", [_vm._v(_vm._s(_vm.getPercent(-2)) + "%")])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mb-0" }, [
      _c("span", { staticClass: "badge badge-warning" }, [_vm._v("К")]),
      _vm._v(": "),
      _c("strong", [
        _vm._v(_vm._s(Math.round((_vm.stats[-3]?.total ?? 0) * 10) / 10)),
      ]),
      _vm._v("\n    ("),
      _c("strong", [_vm._v(_vm._s(_vm.getTotalPrice(_vm.stats[-3]?.price)))]),
      _vm._v(") "),
      _vm.allShift
        ? _c("strong", [_vm._v(_vm._s(_vm.getPercent(-3)) + "%")])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }